/**
 * Hướng dẫn sử dụng — bản mẫu CMS hiển thị tài liệu trong một card. Nội dung ở
 * tệp ngôn ngữ (`vi.huongDan`), mô tả đúng các chức năng của hệ thống này.
 */
import type { ReactNode } from 'react';
import { vi } from '../ngon-ngu/vi';

export function HuongDanSuDung(): ReactNode {
  const h = vi.huongDan;
  return (
    <section className="man-hinh huong-dan" data-man-hinh="huong-dan">
      <h1>{h.tieuDe}</h1>
      <p>{h.moDau}</p>
      {h.phan.map((p) => (
        <section key={p.tieuDe}>
          <h2>{p.tieuDe}</h2>
          <ol>
            {p.buoc.map((b) => (
              <li key={b}>{b}</li>
            ))}
          </ol>
        </section>
      ))}
    </section>
  );
}
